import { ViewCamerasComponent } from './../view-cameras/view-cameras.component';
import { take } from 'rxjs/operators';
import { VideoStreamProviderService } from './../video-stream-provider.service';
import { AlertController, ModalController } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';
import { Clipboard } from '@capacitor/clipboard';

interface TokenItem {
  name: string;
  token: string;
}

@Component({
  standalone: false,
  selector: 'app-tracktennis',
  templateUrl: './tracktennis.component.html',
  styleUrls: ['./tracktennis.component.scss'],
})

export class TracktennisComponent implements OnInit {

  videoStreamProviderList;
  token: string;

  constructor(
    private alertController: AlertController,
    private modalController: ModalController,
    private videoStreamProviderService: VideoStreamProviderService
  ) { }

  async ngOnInit() {
    this.getVideoStreamProviderList();
  }

  getVideoStreamProviderList() {
    this.videoStreamProviderService
      .getVideoStreamProviderList()
      .pipe(take(1))
      .subscribe(
        async res => {
          this.videoStreamProviderList = res.data;
          setTimeout(async () => {
            await this.getTokenFromClipboard();
          });
        }
      )

  }

  getAvatarImg(username: string) {
    switch (username) {
      case 'playsight':
        return 'assets/img/logo/playsight/avatar.png';
      case 'tracktennis':
        return 'assets/img/logo/tracktennis/avatar.jpg';
      default:
        break;
    }
  }

  async deleteProvider(index) {
    const alert = await this.alertController.create({
      header: 'Delete token',
      message: 'Are you sure you want to delete token? This action cannot be undone',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
        }, {
          text: 'Delete',
          role: 'destructive',
          handler: () => {
            // this.tokenItems.splice(index, 1);
          }
        }
      ]
    });
  
    await alert.present();
  }

  updateProvider(index) {
    //console.log('update provider');
    
  }

  async getTokenFromClipboard() {
    const { type, value } = await Clipboard.read();
    
    if (type === 'text/plain' && value.includes('Receiver')) {
      const alert = await this.alertController.create({
        header: 'Copy token',
        message: value,
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            cssClass: 'secondary',
          }, {
            text: 'Copy',
            handler: () => {
              this.token = value
            }
          }
        ]
      });

      await alert.present();

    }
  
  }

  saveToken() {
    this.videoStreamProviderService
      .updateCameras('tracktennis', this.token)
      .pipe(take(1))
      .subscribe({
        next: async res => {
          await this.modalController.dismiss(res)
        }
      })
  }


  async viewCameras(index: number) {
    const modal = await this.modalController.create({
      component: ViewCamerasComponent,
      componentProps: { 
        videoStreamProvider: this.videoStreamProviderList[index],
        isSelectable: false
      }
    });
  
    await modal.present();
  
  }
}
